export default __webpack_public_path__ + "static/media/mathspic3.26fc06a7.jpeg";